import { format } from "date-fns";

interface CalendarEventData {
  title: string;
  description: string;
  location: string;
  startDate: Date;
  endDate: Date;
}

// Format date for Google Calendar (YYYYMMDDTHHmmssZ format)
function formatGoogleDate(date: Date): string {
  return format(date, "yyyyMMdd'T'HHmmss");
}

// Format date for ICS file (YYYYMMDDTHHMMSS format)
function formatICSDate(date: Date): string {
  return format(date, "yyyyMMdd'T'HHmmss");
}

// Generate Google Calendar URL
export function generateGoogleCalendarUrl(event: CalendarEventData): string {
  const baseUrl = "https://calendar.google.com/calendar/render";
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title,
    dates: `${formatGoogleDate(event.startDate)}/${formatGoogleDate(event.endDate)}`,
    details: event.description,
    location: event.location,
    ctz: "Europe/Paris",
  });

  return `${baseUrl}?${params.toString()}`;
}

// Generate ICS file content
export function generateICSContent(event: CalendarEventData): string {
  const now = new Date();
  const uid = `${Date.now()}@regarddenature.fr`;

  return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//REGARD DE NATURE//Naturopathie & Iridologie//FR
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:${uid}
DTSTAMP:${formatICSDate(now)}
DTSTART;TZID=Europe/Paris:${formatICSDate(event.startDate)}
DTEND;TZID=Europe/Paris:${formatICSDate(event.endDate)}
SUMMARY:${event.title}
DESCRIPTION:${event.description.replace(/\n/g, "\\n")}
LOCATION:${event.location}
STATUS:CONFIRMED
END:VEVENT
END:VCALENDAR`;
}

// Download ICS file
export function downloadICSFile(event: CalendarEventData): void {
  const icsContent = generateICSContent(event);
  const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement("a");
  link.href = url;
  link.download = `${event.title.replace(/[^a-zA-Z0-9]/g, "_")}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
